import { useState, useEffect, useCallback } from 'react';
import { api } from '@/utils/api';

export type WidgetDataMap = Record<string, number | string | null>;

export function useWidgetData(refreshInterval = 60000) {
  const [data, setData] = useState<WidgetDataMap>({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const fetch = useCallback(async () => {
    try {
      setError(null);
      const res = await api.get('/analytics/owner-dashboard');
      if (res.data?.data) setData(res.data.data);
    } catch (err: any) {
      setError(err.response?.data?.error || 'Failed to load dashboard data');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetch();
    const timer = setInterval(fetch, refreshInterval);
    return () => clearInterval(timer);
  }, [fetch, refreshInterval]);

  return { data, loading, error, refetch: fetch };
}
